export default __webpack_public_path__ + "static/media/more-grey.300c9040.svg";